<template>
  <div class="thought-bubble" :style="position" v-if="visible">
    <div class="bubble">
      {{ content }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    content: String,
    position: Object,
  },
};
</script>

<style scoped>
.thought-bubble {
  position: absolute;
  z-index: 1001;
  display: flex;
  align-items: center;
}

.bubble {
  background: #fff;
  border-radius: 20px;
  padding: 10px 15px;
  font-size: 14px;
  color: #435666;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
}
</style>
